import React from 'react';
import { ArrowRight, Calendar, ExternalLinkIcon } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { motion } from 'framer-motion';
export function BlogSection() {
  const {
    t
  } = useLanguage();
  const posts = [{
    title: 'Singderm® ฟิลเลอร์มาตรฐานสากล',
    excerpt: 'ที่คลินิกความงามในกว่า 30 ประเทศเลือกใช้ พร้อมการรับรอง CE พัฒนาด้วยแนวคิด "สมดุล + เป็นธรรมชาติ" เพื่อผลลัพธ์ที่ดูละมุน กลมกลืน และเหมาะกับแต่ละบุคคล',
    date: 'Apr 2026',
    category: 'Product',
    image: 'https://cdn.magicpatterns.com/uploads/jU15M6aXqf4Cuk3eNYUHv2/673859259_122183901410942182_7217029902322325613_n.jpg',
    link: 'https://www.facebook.com/share/p/1JGMB3zbRP/'
  }, {
    title: 'Singderm Universal Filler - ฟิลเลอร์ HA เทคโนโลยี DVS',
    excerpt: 'ฟิลเลอร์ Hyaluronic Acid พัฒนาเทคโนโลยี DVS Cross-linking เนื้อเจลมีความเสถียร ควบคุมการดูดซึมน้ำ คงรูปตามปริมาณที่ใช้ ผ่านมาตรฐาน CE ผลลัพธ์ประมาณ 12 เดือน',
    date: 'Apr 2026',
    category: 'Product',
    image: 'https://cdn.magicpatterns.com/uploads/d23XNiUqoMbaBqqWTTewdT/674274399_122183263802942182_5891749208808200484_n.jpg',
    link: 'https://www.facebook.com/share/p/1JGMB3zbRP/'
  }, {
    title: 'Born from Hangzhou, refined for seamless beauty',
    excerpt: 'แรงบันดาลใจจากต้นกำเนิดแห่งความประณีต ถูกนำมาต่อยอดสู่แนวคิดการใช้ฟิลเลอร์ในยุคปัจจุบัน ที่เน้นความกลมกลืนของใบหน้าและความสมดุล มากกว่าการเปลี่ยนแปลงที่ชัดเจน — ความงามที่ลงตัว เรียบหรู และยังคงความเป็นตัวเอง',
    date: 'Apr 2026',
    category: 'Brand Story',
    image: 'https://cdn.magicpatterns.com/uploads/dsA1PyDYqUKatVgHAJRN2E/678593156_122184458312942182_8037118528575799447_n.jpg',
    images: ['https://cdn.magicpatterns.com/uploads/dsA1PyDYqUKatVgHAJRN2E/678593156_122184458312942182_8037118528575799447_n.jpg', 'https://cdn.magicpatterns.com/uploads/5sZAncXnUPQDakpwW9SyZb/673777050_122184458258942182_2654900483078999810_n.jpg', 'https://cdn.magicpatterns.com/uploads/pwNAoKDcDkAY2tMxxVyUcp/678805382_122184458306942182_3921932559710615237_n.jpg'],
    link: 'https://www.facebook.com/share/p/1CrsxXqREF/'
  }, {
    title: 'Singderm® x DPU - Academia Aesthetic Partnership',
    excerpt: 'ความร่วมมือทางวิชาการด้านความงามระหว่าง Singderm และมหาวิทยาลัยธุรกิจบัณฑิตย์ (DPU) เพื่อยกระดับองค์ความรู้และมาตรฐานการดูแลด้านความงามในประเทศไทย',
    date: 'Jun 2026',
    category: 'Partnership',
    image: 'https://cdn.magicpatterns.com/uploads/vxikqPCPPhLq5gQyXJYZqp/646081147_122175515660942182_1670920459211348985_n.jpg',
    link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid02SFqYJ3DbFcE7rtw7cHRasjhEhEoaJGFY7YXEy7ZWJuCrGxpjJgB8R9JCNcHgVYFsl&id=61578265484726'
  }, {
    title: 'Singderm® x Dr.Jonny - Aesthetic Partnership',
    excerpt: 'ความร่วมมือด้านความงามระหว่าง Singderm และ Dr.Jonny พร้อมประสบการณ์ Universal HA Facial with Lidocaine เพื่อผลลัพธ์ที่นุ่มนวลและเป็นธรรมชาติ',
    date: 'Jun 2026',
    category: 'Partnership',
    image: 'https://cdn.magicpatterns.com/uploads/vWy4LA2oC129WTy9XYHExT/647204110_122175926870942182_8846788125253548482_n.jpg',
    link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid035ReNrhgjGUCftpDh9tvZ6xYGaAxoBXdAhPncmSfVVTtojAZ75FyorUpmohBBmu6ol&id=61578265484726'
  }, {
    title: 'Universal Hyaluronic Acid Dermal Filler',
    excerpt: 'Singderm Universal — Modified Sodium Hyaluronate Gel for Injection ฟิลเลอร์ HA คุณภาพสูง 4mg/mL ขนาด 1×1mL ผ่านมาตรฐานระดับสากลเพื่อความงามที่ยั่งยืน',
    date: 'Jun 2026',
    category: 'Product',
    image: 'https://cdn.magicpatterns.com/uploads/6MtRBGxH2JrPX1876oygD6/696685538_122187111320942182_5164541105336840869_n.jpg',
    link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid02L4D3HREeHqycukLoCZHivHugcu5sc4t49PS6MetAVo9eLyMiLhiPh9SviStDFJqRl&id=61578265484726'
  }];
  return <section id="blog" className="py-24 bg-brand-bg" data-id="element-71">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16" data-id="element-73">
          <div className="max-w-2xl" data-id="element-74">
            <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-3" data-id="element-75">
              {t('blog.label')}
            </h2>
            <h3 className="text-3xl md:text-4xl font-light text-gray-900" data-id="element-76">
              {t('blog.title1')}{' '}
              <span className="font-semibold" data-id="element-77">{t('blog.title2')}</span>
            </h3>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-78">
          {posts.map((post, index) => <motion.article key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow flex flex-col h-full" data-id="element-79">
              <div className="aspect-[16/9] bg-gray-100 relative overflow-hidden" data-id="element-80">
                {post.image ? <img src={post.image} alt={post.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-81" /> : <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-brand-copper/10 to-brand-lightCopper/20" data-id="element-82">
                    <span className="text-brand-copper font-semibold text-lg tracking-wide" data-id="element-83">
                      Singderm®
                    </span>
                  </div>}
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded text-xs font-semibold text-brand-copper" data-id="element-84">
                  {post.category}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-grow" data-id="element-85">
                <div className="flex items-center text-gray-400 text-xs mb-3" data-id="element-86">
                  <Calendar size={14} className="mr-1.5" data-id="element-87" />
                  {post.date}
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-3 line-clamp-2" data-id="element-88">
                  {post.title}
                </h4>
                <p className="text-gray-600 text-sm mb-6 line-clamp-3 flex-grow" data-id="element-89">
                  {post.excerpt}
                </p>
                <a href={post.link} target="_blank" rel="noopener noreferrer" className="text-brand-copper font-medium text-sm flex items-center hover:text-brand-darkCopper transition-colors mt-auto w-fit" data-id="element-90">
                  {t('blog.readMore')}{' '}
                  <ExternalLinkIcon size={14} className="ml-1.5" data-id="element-91" />
                </a>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}